import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    collapsedNav: false,
    offCanvasNav: false,
    watchGettingStartedIntro: false
};
export const settingSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        toggleCollapsedNav: (state, action) => {
            state.collapsedNav = action.payload;
        },
        toggleOffCanvasNav: (state, action) => {
            state.offCanvasNav = action.payload;
        },
        watchGettingStartedIntro: (state, action) => {
            state.watchGettingStartedIntro = action.payload;
        },
    }
});
export const { toggleCollapsedNav, toggleOffCanvasNav, watchGettingStartedIntro } = settingSlice.actions;
export const watchGettingStartedIntroSelector = (state) => state?.settings?.watchGettingStartedIntro ?? false;
export const boxedLayoutSelector = (state) => state?.settings?.boxedLayout;
export const fixedHeaderSelector = (state) => state?.settings?.fixedHeader;
export const collapsedNavSelector = (state) => state?.settings?.collapsedNav;
export const offCanvasNavSelector = (state) => state?.settings?.offCanvasNav;
export default settingSlice.reducer;
